import { render } from "./allcustomers.vue?vue&type=template&id=0cb28a45&scoped=true"
import script from "./allcustomers.vue?vue&type=script&lang=js"
export * from "./allcustomers.vue?vue&type=script&lang=js"

import "./allcustomers.vue?vue&type=style&index=0&id=0cb28a45&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb28a45"]])

export default __exports__